let users = {}

const addUser = (id, user) => {
  users[id] = user
}

const worker = {
  addUser,
  users
}

module.exports = worker